import { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { db } from '../lib/firebase';
import { useAuth } from '../contexts/AuthContext';

export const useAdmin = () => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        console.log('No user logged in');
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        console.log('Checking admin status for user:', user.uid);
        const adminRef = ref(db, `admins/${user.uid}`);
        const snapshot = await get(adminRef);
        console.log('Admin snapshot:', snapshot.val());
        setIsAdmin(snapshot.exists() && snapshot.val() === true);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setError('Error checking admin status');
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  return { isAdmin, loading, error };
};
